import gql from "graphql-tag";

const UpdateLanguage = gql`
  mutation updateUserLanguage($language: String!) {
    updateUserLanguage(language: $language)
  }
`;

export default UpdateLanguage;
